/* ============================================
 * NICOCHILL Polish — interactive enhancements
 * - IntersectionObserver でスクロール到達アニメ
 * - section ごとに自動的に reveal クラス付与
 * ============================================ */

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // ----- Helpers -----
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ----- Auto-tag sections with reveal classes -----
  // 既存セクションに class を後付け（テーマセクションを書き換えない安全策）
  function autoTag() {
    // セクション全体: reveal 付与
    $$('.shopify-section').forEach((sec) => {
      // ヒーローはCSSアニメーション独自実装なのでスキップ
      if (sec.querySelector('[class*="nicochill-hero-"]')) return;
      sec.classList.add('nc-reveal');
    });

    // フレーバーショーケース: グリッド子要素を staggered 化
    $$('[class*="flavor-showcase-"]').forEach(s => {
      const cards = s.querySelector('.flavor-showcase__grid');
      if (cards) cards.classList.add('nc-reveal-stagger');
    });

    // テック端末: セクション本体に is-visible トリガー対象
    $$('[class*="tech-showcase-"]').forEach(s => s.classList.add('nc-reveal'));

    // 購入フロー
    $$('[class*="purchase-flow-"]').forEach(s => s.classList.add('nc-reveal'));

    // 信頼セクション
    $$('[class*="trust-section-"]').forEach(s => s.classList.add('nc-reveal'));

    // CTA バナー
    $$('[class*="cta-banner-"]').forEach(s => s.classList.add('nc-reveal'));

    // コレクションリストの cards
    $$('.collection-list-wrapper, .collection-list').forEach(s => {
      const grid = s.querySelector('.grid, .cards, ul');
      if (grid) grid.classList.add('nc-reveal-stagger');
    });
  }

  // ----- IntersectionObserver で is-visible 付与 -----
  function setupObserver() {
    const targets = $$('.nc-reveal, .nc-reveal-stagger, .tech-device-showcase, .purchase-flow');
    if (targets.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(t => t.classList.add('is-visible'));
      return;
    }

    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
      // NOTE: threshold must stay 0. A ratio threshold (e.g. 0.12) can never be
      // reached by sections taller than the viewport (e.g. long legal/info pages),
      // leaving them stuck at opacity:0 forever. threshold:0 fires as soon as any
      // part enters the (margin-adjusted) viewport, so tall sections reveal too.
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    targets.forEach(t => obs.observe(t));
  }

  // ----- Smooth anchor scroll with offset (for headers) -----
  function setupSmoothAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      const headerOffset = 80;
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  // ----- Hero subtle parallax on scroll -----
  function setupHeroParallax() {
    const heroImg = document.querySelector('.nicochill-hero .hero-image img, .nicochill-hero img');
    if (!heroImg) return;
    let ticking = false;
    function update() {
      const sc = window.scrollY;
      const offset = Math.min(sc * 0.18, 60);
      heroImg.style.transform = `translateY(${offset}px)`;
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // ----- Init -----
  function init() {
    // Reduce motion preference
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    autoTag();
    if (!reduce) {
      setupObserver();
      setupHeroParallax();
    } else {
      // 全要素を即時可視化
      $$('.nc-reveal, .nc-reveal-stagger').forEach(t => t.classList.add('is-visible'));
    }
    setupSmoothAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================
 * NICOCHILL 年齢確認: チェックなしで checkout 阻止
 * ============================================ */
(function () {
  if (typeof document === 'undefined') return;
  function setup() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('button[name="checkout"], a[href*="/checkout"], button#checkout, [name="checkout"]');
      if (!btn) return;
      const cb = document.getElementById('age-verification-checkbox');
      if (!cb) return; // チェックボックス無いページ（直接 /checkout 等）はスルー
      if (!cb.checked) {
        e.preventDefault();
        e.stopPropagation();
        cb.focus();
        const wrap = cb.closest('.age-confirm');
        if (wrap) {
          wrap.style.transition = 'background-color 0.3s';
          wrap.style.backgroundColor = '#FFE4D9';
          setTimeout(function () { wrap.style.backgroundColor = ''; }, 1500);
        }
        alert('20歳以上であることを確認するチェックボックスにチェックを入れてください。');
      }
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* ============================================
 * NICOCHILL カート内アドオンピッカー付きナッジモーダル
 * - 購入ボタン押下時、「送料の残り」と「個人輸入の残り容量(mL)」を1枚挟む
 * - カートページの購入ボタンだけでなく、カート追加通知ポップアップ
 *   （snippets/cart-notification.liquid の「購入手続きに進む」）からも発火する
 * - モーダル内でPOD単体/デバイス単体をその場でカートに追加できる（/cart/add.js）
 * - 追加後はヘッダーのカートバブルと通知ポップアップの件数を Section Rendering API で同期し、
 *   カートページ本体（描画不可なセクション）は閉じる時のリロードで追従させる
 * - 年齢確認を通過した後にのみ発火（年齢未チェックは従来の年齢ハンドラに委譲）
 * - 同セッション中は一度見たらスキップ（sessionStorage）
 *
 * 重要: このハンドラは e.preventDefault() を呼んだ後に動くため、内部で例外が出ると
 * 購入ボタンが無反応になる。開く経路は必ず try/catch で包み、失敗時は素通りさせること。
 * ============================================ */
(function () {
  if (typeof document === 'undefined') return;

  var SEEN_KEY = 'nc_cart_upsell_seen_v2';
  var AGE_KEY = 'nc_age_confirmed_v1';
  var RE_POD = /^POD\s*\d+$/;
  var RE_DEV = /^デバイス(\d+|本体)$/;
  // ノンニコチン（国内発送・一律¥450）の商品。個人輸入の上限にも送料の段にも数えない。
  // line-bot/lib/shipping-rate.js の FLAT_VENDORS と同じ値にすること。
  var FLAT_VENDOR = 'RICHILL';
  function isFlatLine(line) {
    return String((line && line.vendor) || '').trim().toUpperCase() === FLAT_VENDOR;
  }

  var state = {
    cfg: null,
    addons: null,
    cart: null,
    totalYen: 0,
    // カートが RICHILL の商品だけ（送料は一律で、容量の上限も関係ない）
    flatOnly: false,
    // 当たっている送料無料クーポンのコード（無ければ空）。金額の段より優先して送料0と出す
    freeShipCode: '',
    units: 0,
    unknown: false,
    unitLimit: 6,
    mlPerUnit: 20,
    mlLimit: 120,
    unitMap: {},
    overlay: null,
    busy: false,
    proceeding: false,
    pickerDead: false,
    // 個人輸入の上限を超えているカート。モーダルを「購入できない」状態で出し、
    // 「このまま購入へ進む」を出さない（＝チェックアウトへ行かせない）
    blocked: false,
    dirty: false,
    ageConfirmed: false,
    activeTab: 'pod',
    lastFocus: null,
    trigger: null,
    onKeydown: null,
    scrollY: 0
  };

  /* ---------- 小物 ---------- */

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- 設定JSONの取り寄せ（カートページ以外） ---------- */

  // 設定JSON（#nc-shipping-config / #nc-cart-addons）は sections/main-cart-footer.liquid が
  // 出すのでカートページにしか無い。カート追加通知ポップアップから発火する場合は
  // カートページのHTMLを取り寄せて、JSONアイランドだけを body へ移植する。
  //
  // Section Rendering API（/cart?sections=cart-footer, ?section_id=cart-footer）は使えない。
  // cart-items / cart-footer は常に null / 404 を返す（cart-icon-bubble や
  // cart-notification-button は返る）。2026-07-28 に本番で実測。
  //
  // ページHTMLをそのまま挿すと #checkout などが二重になるため、
  // 取り込むのは script[type="application/json"] の中身だけに限定する。
  var configPromise = null;

  function injectIsland(doc, id) {
    if (document.getElementById(id)) return;
    var src = doc.getElementById(id);
    if (!src) return;
    var el = document.createElement('script');
    el.type = 'application/json';
    el.id = id;
    el.textContent = src.textContent;
    document.body.appendChild(el);
  }

  function ensureConfig() {
    if (document.getElementById('nc-shipping-config')) return Promise.resolve();
    if (configPromise) return configPromise;

    var url = (window.routes && window.routes.cart_url) || '/cart';
    var p = fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        injectIsland(doc, 'nc-shipping-config');
        injectIsland(doc, 'nc-cart-addons');
        if (!document.getElementById('nc-shipping-config')) throw new Error('config island missing');
      });

    configPromise = p;
    // 失敗を握り潰さずに次回クリックで再試行できるようにする（unhandled rejection も防ぐ）
    p.catch(function () { if (configPromise === p) configPromise = null; });
    return p;
  }

  // カートページHTMLの取得は約120KB・実測350ms前後かかる。通知ポップアップの購入ボタンを
  // 押した時点から取りに行くと待たせるので、「カートに追加」した時点で先読みしておく
  // （＝通知ポップアップが出る直前。失敗しても本経路の ensureConfig が再試行する）。
  function warmConfig() {
    if (document.getElementById('nc-shipping-config')) return;
    try { ensureConfig().catch(function () {}); } catch (e) {}
  }

  // Dawn のカート通知は開いている間 body クリック監視と focus trap を張るので、
  // モーダルを重ねる前に閉じる。close() はクラスを外すだけでDOMは残るため、
  // 通知内の購入ボタン（＝再送信先のフォーム）はそのまま使える。
  function closeCartNotification() {
    try {
      var el = document.querySelector('cart-notification');
      if (el && typeof el.close === 'function') el.close();
    } catch (e) {}
  }

  function yen(n) {
    return '¥' + Math.round(n).toLocaleString('ja-JP');
  }

  function make(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // 画像URLはLiquidの image_url が生成したものだけが入る（利用者入力ではない）。
  // ホスト名は環境で変わる（cdn.shopify.com / 独自ドメインの /cdn/shop/...）ので固定せず、
  // javascript: や data: を弾くためにスキームだけ検証する。
  function safeImg(url) {
    if (!url || typeof url !== 'string') return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return /^https?:\/\//i.test(u) ? u : '';
  }

  /* ---------- 液量計算 ---------- */

  // 1行あたりの単位数。一次ソースは line item property（line-bot/lib/set-breakdown.js と同じ契約）、
  // 単体商品は property を持たないので unitMap で補う。
  // 2つのシグナルは逆方向に失敗する（property は過小、unitMap は陳腐化）ため大きい方を採り、
  // 上限判定が常に安全側（多めに数えて追加を止める）に倒れるようにする。
  function unitsForLine(line) {
    var n = 0;
    var props = (line && line.properties) || {};
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k.charAt(0) === '_') continue;                       // _line_link 等の隠しプロパティ
      var val = props[k];
      if (val == null || String(val).trim() === '') continue;
      if (RE_POD.test(k) || RE_DEV.test(k)) n++;
    }
    var declared = Number(state.unitMap[String(line.variant_id)] || 0);
    var per = Math.max(n, declared);
    return { units: per * (Number(line.quantity) || 0), known: per > 0 };
  }

  function computeUnits(cart) {
    var units = 0;
    var unknown = false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (!items[i].quantity) continue;
      // ノンニコチンは液量の上限の対象外。unitMap に無いので「不明」扱いにもしない
      if (isFlatLine(items[i])) continue;
      var r = unitsForLine(items[i]);
      units += r.units;
      if (!r.known) unknown = true;
    }
    return { units: units, unknown: unknown };
  }

  // 送料無料クーポンは送料にだけ効くので total_price に表れない。/cart.js の discount_codes
  // （{ code, applicable }）に、設定のコード一覧（snippets/nc-free-shipping-codes.liquid）の
  // どれかが applicable で載っているかで見る。
  // 「CODE:5000」のように下限がある行は、カートの合計が下限に届くときだけ当たり扱いにする
  // （/cart.js の applicable は下限を見ずに true を返す。2026-10-19 FRSHP_FIRST で実測）。
  function findFreeShipCode(cart, codes) {
    var wanted = {};
    (codes || []).forEach(function (c) {
      var parts = String(c || '').split(':');
      var k = parts[0].trim().toUpperCase();
      if (k) wanted[k] = parseInt(parts[1], 10) || 0;
    });
    var totalYen = (Number(cart && cart.total_price) || 0) / 100;
    var applied = (cart && cart.discount_codes) || [];
    for (var i = 0; i < applied.length; i++) {
      var d = applied[i] || {};
      var code = String(d.code || '').trim().toUpperCase();
      if (d.applicable === true && Object.prototype.hasOwnProperty.call(wanted, code)
        && totalYen >= wanted[code]) return String(d.code).trim();
    }
    return '';
  }

  function applyCart(cart) {
    state.cart = cart;
    // 送料の段の基準額。規則の正本は line-bot/lib/shipping-rate.js（チェックアウトで実際に
    // 送料を返している側）で、半額クーポン(50OFF_RICHILL)のときだけ割引前の商品合計、
    // それ以外のクーポンは割引後の金額で判定する。ここを total_price だけで見ると
    // 「あと¥Xで送料無料」の案内と実際の請求がずれる。
    //
    // RICHILL の行は段の判定に入れない（混載ならニコチン側の金額だけで段を決める）。
    // クーポンは RICHILL に効かないので、割引はまるごとニコチン側から引き、
    // 半額の判定もニコチン側の金額で見る。
    var grossMinor = Number(cart && cart.original_total_price) || 0;
    var netMinor = Number(cart && cart.total_price) || 0;
    var discountMinor = grossMinor - netMinor;
    var lines = (cart && cart.items) || [];
    var flatMinor = 0;
    var flatLines = 0;
    for (var li = 0; li < lines.length; li++) {
      if (!isFlatLine(lines[li])) continue;
      flatMinor += Number(lines[li].original_line_price) || 0;
      flatLines++;
    }
    var nicoGross = Math.max(0, grossMinor - flatMinor);
    var halfOff = nicoGross > 0 && discountMinor > 0
      && Math.abs(discountMinor / nicoGross - 0.5) <= 0.01;
    state.totalYen = Math.floor((halfOff ? nicoGross : Math.max(0, nicoGross - discountMinor)) / 100);
    state.flatOnly = lines.length > 0 && flatLines === lines.length;
    var shipCfg = state.cfg || readJson('nc-shipping-config');
    state.freeShipCode = findFreeShipCode(cart, shipCfg && shipCfg.freeShippingCodes);
    var u = computeUnits(cart);
    state.units = u.units;
    state.unknown = u.unknown;
    var attrs = (cart && cart.attributes) || {};
    if (String(attrs.age_confirmed) === 'true') {
      state.ageConfirmed = true;
      try { sessionStorage.setItem(AGE_KEY, '1'); } catch (e) {}
    }
  }

  /* ---------- 年齢確認 ---------- */

  // カートページの購入ボタンは #age-verification-checkbox を通らないとここまで来ない。
  // 通知ポップアップ経由にはそれが無いので、モーダル内で確認を取る。
  function ageRequired() {
    return !document.getElementById('age-verification-checkbox') && !state.ageConfirmed;
  }

  // 注文に記録を残すため、カートページのチェックボックスと同じ cart attribute を立てる
  function confirmAgeOnCart() {
    state.ageConfirmed = true;
    try { sessionStorage.setItem(AGE_KEY, '1'); } catch (e) {}
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { age_confirmed: 'true' } })
    }).catch(function () { /* 記録に失敗しても確認済みの扱いは維持する */ });
  }

  function remainingUnits() {
    return Math.max(0, state.unitLimit - state.units);
  }

  /* ---------- 送料の文脈 ---------- */

  function shippingCtx() {
    var cfg = state.cfg;
    var threshold = Number(cfg.threshold) || 0;
    var midThreshold = Number(cfg.midThreshold) || 0;
    var baseFee = Number(cfg.baseFee) || 0;
    var midFee = Number(cfg.midFee) || 0;
    var total = state.totalYen;

    var hasMid = midThreshold > 0 && midFee > 0 && midFee < baseFee && midThreshold < threshold;
    var byCoupon = !!state.freeShipCode;
    var achieved = byCoupon || (threshold > 0 && total >= threshold);
    var currentFee = achieved ? 0 : ((hasMid && total >= midThreshold) ? midFee : baseFee);

    var steps = [];
    if (byCoupon) {
      // 金額の段の話（あと¥Xで…）は出さない。クーポンで送料無料なのに買い足しを促すと混乱する
      steps.push({ text: '送料無料クーポン（' + state.freeShipCode + '）が適用されています', done: true });
    } else if (achieved) {
      steps.push({ text: '送料無料を達成しています', done: true });
    } else {
      if (hasMid && total < midThreshold && midThreshold - total > 0) {
        steps.push({ text: 'あと' + yen(midThreshold - total) + 'のご購入で送料が' + yen(midFee) + 'に', done: false });
      }
      if (threshold - total > 0) {
        steps.push({ text: 'あと' + yen(threshold - total) + 'のご購入で送料無料', done: false });
      }
    }
    return { achieved: achieved, byCoupon: byCoupon, currentFee: currentFee, baseFee: baseFee, steps: steps };
  }

  /* ---------- 描画 ---------- */

  function renderShipping() {
    var ov = state.overlay;
    if (!ov) return;

    // 上限超過で購入できない状態のときに送料の話をしても意味がないので出さない
    if (state.blocked) {
      var blockedHeading = ov.querySelector('.nc-ship-modal__heading');
      if (blockedHeading) blockedHeading.textContent = 'このままではご購入いただけません';
      var blockedSave = ov.querySelector('.nc-ship-modal__save');
      if (blockedSave) blockedSave.hidden = true;
      var blockedSteps = ov.querySelector('.nc-ship-modal__steps');
      if (blockedSteps) blockedSteps.hidden = true;
      return;
    }

    var ctx = shippingCtx();
    var cfg = state.cfg;

    var headingEl = ov.querySelector('.nc-ship-modal__heading');
    if (headingEl) {
      headingEl.textContent = ctx.byCoupon
        ? 'クーポンで送料無料です！'
        : ctx.achieved
        ? (cfg.headingFree || '送料無料を達成しています！')
        : (cfg.heading || 'あと少しで送料無料！');
    }

    var save = ov.querySelector('.nc-ship-modal__save');
    if (save) {
      save.innerHTML = '';
      if (ctx.baseFee > 0) {
        save.hidden = false;
        if (ctx.achieved) {
          save.classList.add('nc-ship-modal__save--achieved');
          save.appendChild(make('span', 'nc-ship-modal__save-label', '送料'));
          save.appendChild(make('span', 'nc-ship-modal__save-free', '0円（無料）'));
        } else {
          save.classList.remove('nc-ship-modal__save--achieved');
          save.appendChild(make('span', 'nc-ship-modal__save-label', '現在の送料'));
          save.appendChild(make('span', 'nc-ship-modal__save-was', yen(ctx.currentFee)));
          var arrow = make('span', 'nc-ship-modal__save-arrow', '→');
          arrow.setAttribute('aria-hidden', 'true');
          save.appendChild(arrow);
          save.appendChild(make('span', 'nc-ship-modal__save-free', '0円'));
        }
      } else {
        save.hidden = true;
      }
    }

    var steps = ov.querySelector('.nc-ship-modal__steps');
    if (steps) {
      steps.innerHTML = '';
      for (var i = 0; i < ctx.steps.length; i++) {
        var li = make('li', 'nc-ship-modal__step' + (ctx.steps[i].done ? ' nc-ship-modal__step--done' : ''), ctx.steps[i].text);
        steps.appendChild(li);
      }
      steps.hidden = ctx.steps.length === 0;
    }
  }

  function renderCapacity() {
    var ov = state.overlay;
    if (!ov) return;
    var box = ov.querySelector('.nc-ml');
    if (!box) return;
    var a = state.addons || {};

    box.classList.remove('nc-ml--full', 'nc-ml--over', 'nc-ml--unknown');

    var bar = box.querySelector('.nc-ml__bar');
    var fill = box.querySelector('.nc-ml__fill');
    var now = box.querySelector('.nc-ml__now');
    var rest = box.querySelector('.nc-ml__rest');
    var note = box.querySelector('.nc-ml__note');

    if (note) note.textContent = a.capacityLabel || '';

    if (state.unknown) {
      box.classList.add('nc-ml--unknown');
      if (bar) bar.hidden = true;
      if (now) now.textContent = '';
      if (rest) rest.textContent = a.unknownText || '残りの容量を確認できませんでした';
      return;
    }

    var usedMl = state.units * state.mlPerUnit;
    var left = remainingUnits();
    var pct = state.unitLimit > 0 ? Math.min(100, (state.units / state.unitLimit) * 100) : 0;

    if (bar) {
      bar.hidden = false;
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', String(state.mlLimit));
      bar.setAttribute('aria-valuenow', String(Math.min(usedMl, state.mlLimit)));
      bar.setAttribute('aria-valuetext', state.mlLimit + 'mL中 ' + usedMl + 'mL、あと' + (left * state.mlPerUnit) + 'mL');
    }
    if (fill) fill.style.width = pct + '%';
    if (now) now.textContent = '現在 ' + usedMl + 'mL（' + state.units + '個）';

    if (state.units > state.unitLimit) {
      box.classList.add('nc-ml--over');
      if (rest) rest.textContent = a.overWarning || '上限を超えています。数量をご確認ください。';
    } else if (left === 0) {
      box.classList.add('nc-ml--full');
      if (rest) rest.textContent = a.fullText || '上限に達しました';
    } else {
      if (rest) rest.textContent = 'あと ' + (left * state.mlPerUnit) + 'mL（' + left + '個）まで追加できます';
    }
  }

  function syncPicker() {
    var ov = state.overlay;
    if (!ov) return;
    var picker = ov.querySelector('.nc-addons');
    if (!picker) return;

    var blocked = state.pickerDead || state.unknown || state.units > state.unitLimit;
    picker.classList.toggle('nc-addons--disabled', blocked);
    picker.setAttribute('aria-busy', state.busy ? 'true' : 'false');

    var left = remainingUnits();
    picker.classList.toggle('nc-addons--full', !blocked && left === 0);

    var cards = picker.querySelectorAll('.nc-addon');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var btn = card.querySelector('.nc-addon__add');
      var badge = card.querySelector('.nc-addon__badge');
      var oos = card.getAttribute('data-oos') === '1';
      var disabled = blocked || state.busy || left === 0 || oos;
      if (btn) btn.disabled = disabled;
      card.classList.toggle('is-disabled', disabled && !state.busy);
      if (badge) {
        if (oos) {
          badge.textContent = (state.addons && state.addons.soldOutLabel) || '在庫切れ';
          badge.hidden = false;
        } else if (!blocked && left === 0) {
          badge.textContent = (state.addons && state.addons.fullText) || '上限に達しました';
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    }
  }

  function announce(msg) {
    var ov = state.overlay;
    if (!ov) return;
    var s = ov.querySelector('.nc-addons__status');
    if (s) s.textContent = msg;
  }

  /* ---------- ピッカーDOM ---------- */

  function buildPicker() {
    var a = state.addons;
    if (!a || !a.enabled) return null;
    var groups = (a.groups || []).filter(function (g) { return g && g.items && g.items.length; });
    if (!groups.length) return null;

    var wrap = make('div', 'nc-addons');
    wrap.appendChild(make('h3', 'nc-addons__heading', a.heading || '上限までまとめ買いがおトクです'));

    var tabs = make('div', 'nc-addons__tabs');
    tabs.setAttribute('role', 'tablist');
    wrap.appendChild(tabs);

    if (groups.length && state.activeTab !== groups[0].key) {
      var hasActive = groups.some(function (g) { return g.key === state.activeTab; });
      if (!hasActive) state.activeTab = groups[0].key;
    }

    groups.forEach(function (g) {
      var tab = make('button', 'nc-addons__tab');
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('data-nc-tab', g.key);
      tab.id = 'nc-addons-tab-' + g.key;
      tab.setAttribute('aria-controls', 'nc-addons-panel-' + g.key);

      // タブに代表商品のサムネイルを載せる（POD/デバイスの形の違いが一目で分かる）
      var thumbSrc = '';
      for (var ti = 0; ti < g.items.length && !thumbSrc; ti++) thumbSrc = safeImg(g.items[ti].img);
      if (thumbSrc) {
        var thumb = document.createElement('img');
        thumb.className = 'nc-addons__tab-img';
        thumb.src = thumbSrc;
        thumb.alt = '';
        thumb.loading = 'lazy';
        thumb.width = 40;
        thumb.height = 40;
        tab.appendChild(thumb);
      }
      tab.appendChild(make('span', 'nc-addons__tab-label', g.label || g.key));
      tabs.appendChild(tab);

      var panel = make('div', 'nc-addons__panel');
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('data-nc-panel', g.key);
      panel.id = 'nc-addons-panel-' + g.key;
      panel.setAttribute('aria-labelledby', 'nc-addons-tab-' + g.key);

      var grid = make('div', 'nc-addons__grid');
      g.items.forEach(function (item) {
        grid.appendChild(buildCard(item));
      });
      panel.appendChild(grid);
      wrap.appendChild(panel);
    });

    var status = make('div', 'nc-addons__status visually-hidden');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    wrap.appendChild(status);

    tabs.addEventListener('click', function (e) {
      var t = e.target.closest('.nc-addons__tab');
      if (!t) return;
      selectTab(t.getAttribute('data-nc-tab'));
    });
    tabs.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var all = Array.prototype.slice.call(tabs.querySelectorAll('.nc-addons__tab'));
      var idx = all.indexOf(document.activeElement);
      if (idx < 0) return;
      e.preventDefault();
      var next = all[(idx + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
      selectTab(next.getAttribute('data-nc-tab'));
      next.focus();
    });

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.nc-addon__add');
      if (!btn || btn.disabled) return;
      var card = btn.closest('.nc-addon');
      if (!card) return;
      addToCart(card);
    });

    return wrap;
  }

  function buildCard(item) {
    var card = make('div', 'nc-addon');
    card.setAttribute('data-variant-id', String(item.id));
    if (item.color) card.style.setProperty('--nc-flavor', item.color);
    if (item.available === false) card.setAttribute('data-oos', '1');

    var src = safeImg(item.img);
    if (src) {
      var img = document.createElement('img');
      img.className = 'nc-addon__img';
      img.src = src;
      var src2 = safeImg(item.img2x);
      if (src2) img.srcset = src + ' 1x, ' + src2 + ' 2x';
      img.alt = '';
      img.loading = 'lazy';
      img.width = 120;
      img.height = 120;
      card.appendChild(img);
    }

    card.appendChild(make('div', 'nc-addon__name', item.name || ''));

    var prices = make('div', 'nc-addon__prices');
    if (item.compareAt && Number(item.compareAt) > Number(item.price)) {
      prices.appendChild(make('s', 'nc-addon__was', yen(item.compareAt)));
    }
    prices.appendChild(make('span', 'nc-addon__now', yen(item.price)));
    card.appendChild(prices);

    var badge = make('span', 'nc-addon__badge', '');
    badge.hidden = true;
    card.appendChild(badge);

    var err = make('p', 'nc-addon__err', '');
    err.hidden = true;
    card.appendChild(err);

    var btn = make('button', 'nc-addon__add', (state.addons && state.addons.addLabel) || '追加する');
    btn.type = 'button';
    btn.setAttribute('aria-label', (item.name || '') + 'を1個追加する');
    card.appendChild(btn);

    return card;
  }

  function selectTab(key) {
    var ov = state.overlay;
    if (!ov || !key) return;
    state.activeTab = key;
    var tabs = ov.querySelectorAll('.nc-addons__tab');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-nc-tab') === key;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
      tabs[i].classList.toggle('is-active', on);
    }
    var panels = ov.querySelectorAll('.nc-addons__panel');
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute('data-nc-panel') !== key;
    }
  }

  /* ---------- カート追加 ---------- */

  // 追加後に同期し得る差し替え先の一覧。
  // cart-items / cart-footer は入れないこと。Section Rendering API がこの2つに対しては
  // 常に null を返すため（2026-07-28 本番実測）、要求しても無駄で、カートページの
  // 表示更新は state.dirty → 閉じる時のリロードで担保している。
  var SECTION_MAP = [
    { id: 'cart-icon-bubble', target: '#cart-icon-bubble', selector: '.shopify-section' },
    // 通知ポップアップの「カートを見る (n)」。件数テキストだけを描画するセクション
    { id: 'cart-notification-button', target: '#cart-notification-button', selector: '.shopify-section' }
  ];

  // 実際にこのページに存在する差し替え先だけを対象にする。
  // 無いセクションを要求してもレンダリングが無駄になるだけなので、要求自体もこの結果から作る。
  function sectionPlan() {
    return SECTION_MAP.filter(function (m) { return !!document.querySelector(m.target); });
  }

  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    sectionPlan().forEach(function (m) {
      var html = sections[m.id];
      if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');
      var src = doc.querySelector(m.selector) || doc.body;
      var dst = document.querySelector(m.target + ' ' + m.selector) || document.querySelector(m.target);
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
  }

  function addToCart(card) {
    if (state.busy) return;
    var variantId = Number(card.getAttribute('data-variant-id'));
    if (!variantId) return;
    if (remainingUnits() < 1) { syncPicker(); return; }

    var errEl = card.querySelector('.nc-addon__err');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    // 年齢確認は .js-contents の外なので差し替え対象外だが、将来のマークアップ変更に備えて保全する
    var ageCb = document.getElementById('age-verification-checkbox');
    var ageWas = ageCb ? ageCb.checked : null;

    state.busy = true;
    card.classList.add('is-loading');
    syncPicker();

    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    var wanted = sectionPlan().map(function (m) { return m.id; }).join(',');
    var payload = { items: [{ id: variantId, quantity: 1 }] };
    if (wanted) {
      payload.sections = wanted;
      payload.sections_url = window.location.pathname;
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) {
          var msg = (r.data && (r.data.description || r.data.message)) || '追加できませんでした';
          if (r.status === 422) {
            card.setAttribute('data-oos', '1');
          }
          if (errEl) { errEl.textContent = String(msg).slice(0, 120); errEl.hidden = false; }
          announce(msg);
          return refreshCart();
        }
        state.dirty = true;
        applySections(r.data && r.data.sections);
        if (ageCb && ageWas !== null) {
          var ageNow = document.getElementById('age-verification-checkbox');
          if (ageNow && ageNow.checked !== ageWas) ageNow.checked = ageWas;
        }
        // 差し替えで購入導線の要素が消えていないか確認（消えていてもピッカーだけ止め、購入は維持）
        if (!document.getElementById('nc-shipping-config') || !resolveCheckoutBtn()) {
          state.pickerDead = true;
          if (window.console && console.warn) console.warn('[nicochill] cart DOM changed unexpectedly; picker disabled');
        }
        var name = (card.querySelector('.nc-addon__name') || {}).textContent || '商品';
        return refreshCart().then(function () {
          announce(name + 'を1個追加しました。残り ' + (remainingUnits() * state.mlPerUnit) + 'mL');
        });
      })
      .catch(function () {
        if (errEl) { errEl.textContent = '通信に失敗しました。もう一度お試しください。'; errEl.hidden = false; }
      })
      .then(function () {
        state.busy = false;
        card.classList.remove('is-loading');
        syncPicker();
      });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyCart(cart);
        renderShipping();
        renderCapacity();
        syncPicker();
      })
      .catch(function () { /* 表示更新に失敗しても購入導線は維持する */ });
  }

  /* ---------- モーダル ---------- */

  // 年齢確認ブロック。チェックが入るまで「このまま購入へ進む」を押せなくする。
  function buildAge() {
    if (!ageRequired()) return null;

    var wrap = make('div', 'nc-age');
    var label = make('label', 'nc-age__label');
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'nc-age__check';
    cb.id = 'nc-age-confirm';
    label.appendChild(cb);
    label.appendChild(make('span', 'nc-age__text', '私は20歳以上です'));
    wrap.appendChild(label);

    var link = make('a', 'nc-age__link', '20歳未満の方はこちら');
    link.href = '/pages/under-20-notice';
    wrap.appendChild(link);

    var err = make('p', 'nc-age__err', '20歳以上であることを確認するチェックを入れてください。');
    err.hidden = true;
    wrap.appendChild(err);

    cb.addEventListener('change', function () {
      err.hidden = true;
      if (cb.checked) confirmAgeOnCart();
      syncAge();
    });
    return wrap;
  }

  function syncAge() {
    var ov = state.overlay;
    if (!ov) return;
    if (state.blocked) return;   // 上限超過モーダルには年齢確認も購入ボタンも無い
    var cb = ov.querySelector('.nc-age__check');
    var go = ov.querySelector('.nc-ship-modal__proceed');
    if (!go) return;
    var blocked = !!cb && !cb.checked;
    go.disabled = blocked;
    go.setAttribute('aria-disabled', blocked ? 'true' : 'false');
  }

  function getFocusable() {
    if (!state.overlay) return [];
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(state.overlay.querySelectorAll(sel)).filter(function (n) {
      return n.offsetParent !== null || n === document.activeElement;
    });
  }

  function lockScroll() {
    state.scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('nc-modal-open');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('nc-modal-open');
  }

  function closeNudge() {
    try {
      if (state.onKeydown) {
        document.removeEventListener('keydown', state.onKeydown, true);
        state.onKeydown = null;
      }
      if (state.overlay && state.overlay.parentNode) {
        state.overlay.parentNode.removeChild(state.overlay);
      }
    } finally {
      state.overlay = null;
      state.busy = false;
      unlockScroll();
      var back = resolveCheckoutBtn() || state.lastFocus;
      if (back && back.focus) { try { back.focus(); } catch (e) {} }
      state.lastFocus = null;
    }
  }

  // 押された購入ボタンを最優先で使う（通知ポップアップ内のボタンは #checkout ではなく、
  // 送信先も #cart ではなく #cart-notification-form のため）。
  // カートページでは差し替えで元のボタンがDOMから外れるので、その時だけ引き直す。
  // ユーザー操作で閉じるとき用。カートページはモーダル内で追加した分が反映されていない
  // （cart-items / cart-footer は Section Rendering API で描画できない）ので、
  // 追加があった場合だけ読み直す。購入へ進む経路では呼ばない（遷移を潰さないため）。
  function dismissNudge() {
    var stale = state.dirty && !!document.getElementById('main-cart-items');
    closeNudge();
    if (stale) window.location.reload();
  }

  function resolveCheckoutBtn() {
    var t = state.trigger;
    if (t && document.contains(t)) return t;
    return document.getElementById('checkout') || document.querySelector('button[name="checkout"]');
  }

  function submitCheckout() {
    // 上限超過と分かっている間は、どの経路（proceed / bailOut / passThrough）から
    // 呼ばれてもチェックアウトへは送らない
    if (state.blocked) return;
    var btn = resolveCheckoutBtn();
    var form = (btn && btn.form) || document.getElementById('cart');
    if (!form) { window.location.href = '/checkout'; return; }
    try {
      if (btn && form.requestSubmit) form.requestSubmit(btn);
      else if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    } catch (e) {
      try { form.submit(); } catch (e2) { window.location.href = '/checkout'; }
    }
  }

  function proceed() {
    if (state.proceeding) return;

    // 個人輸入の上限を超えたカートは、どの経路からも購入へ進ませない
    if (state.blocked) return;

    // 年齢未確認のまま購入へ進ませない
    var ov = state.overlay;
    var cb = ov && ov.querySelector('.nc-age__check');
    if (cb && !cb.checked) {
      var err = ov.querySelector('.nc-age__err');
      if (err) err.hidden = false;
      try { cb.focus(); } catch (e) {}
      return;
    }

    state.proceeding = true;
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    closeNudge();
    submitCheckout();
  }

  function openNudge() {
    var overlay = make('div', 'nc-ship-overlay');
    overlay.id = 'nc-ship-overlay';
    state.overlay = overlay;

    var modal = make('div', 'nc-ship-modal nc-ship-modal--picker' + (state.blocked ? ' nc-ship-modal--blocked' : ''));
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'nc-ship-title');
    modal.tabIndex = -1;
    overlay.appendChild(modal);

    var head = make('div', 'nc-ship-modal__head');
    var emoji = make('div', 'nc-ship-modal__emoji', state.blocked ? '⚠️' : '🚚');
    emoji.setAttribute('aria-hidden', 'true');
    head.appendChild(emoji);
    var h2 = make('h2', 'nc-ship-modal__heading', '');
    h2.id = 'nc-ship-title';
    head.appendChild(h2);
    var close = make('button', 'nc-ship-modal__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', '閉じる');
    head.appendChild(close);
    modal.appendChild(head);

    var body = make('div', 'nc-ship-modal__body');
    if (state.blocked) {
      // 上限超過はここで初めて「買えない理由」を出す。送料の話は不要なので出さない。
      var alert = make('div', 'nc-ship-modal__alert');
      alert.setAttribute('role', 'alert');
      alert.appendChild(make('p', 'nc-ship-modal__alert-title',
        '個人輸入の上限（1ヶ月あたり' + state.mlLimit + 'mL）を超えています'));
      alert.appendChild(make('p', 'nc-ship-modal__alert-body',
        '現在カートに入っているのは ' + (state.units * state.mlPerUnit) + 'mL 分'
        + '（POD・デバイス' + state.units + '個／1個＝' + state.mlPerUnit + 'mL）です。'
        + 'ご購入いただくには、' + state.mlLimit + 'mL（' + state.unitLimit + '個）以下になるよう'
        + 'カートの数量を減らしてください。'));
      body.appendChild(alert);
    }
    body.appendChild(make('div', 'nc-ship-modal__save'));
    body.appendChild(make('ul', 'nc-ship-modal__steps'));

    var ml = make('div', 'nc-ml');
    var bar = make('div', 'nc-ml__bar');
    bar.setAttribute('role', 'progressbar');
    bar.appendChild(make('div', 'nc-ml__fill'));
    ml.appendChild(bar);
    ml.appendChild(make('p', 'nc-ml__now', ''));
    ml.appendChild(make('p', 'nc-ml__rest', ''));
    ml.appendChild(make('p', 'nc-ml__note', ''));
    body.appendChild(ml);

    // 上限超過中はピッカー（買い足し）自体を出さない
    var picker = state.blocked ? null : buildPicker();
    if (picker) body.appendChild(picker);
    modal.appendChild(body);

    // 上限超過中は購入へ進めないので年齢確認も取らない
    var age = state.blocked ? null : buildAge();
    if (age) modal.appendChild(age);

    var actions = make('div', 'nc-ship-modal__actions');
    var cont = make('button', 'button button--secondary nc-ship-modal__continue',
      state.blocked ? '閉じる' : '買い物を続ける');
    cont.type = 'button';
    actions.appendChild(cont);

    var go = null;
    if (state.blocked) {
      // 「購入へ進む」は出さない。行き先はカート（数量を直す場所）だけ。
      var fix = make('a', 'button nc-ship-modal__proceed nc-ship-modal__fix', 'カートの数量を見直す');
      fix.href = (window.routes && window.routes.cart_url) || '/cart';
      actions.appendChild(fix);
    } else {
      go = make('button', 'button nc-ship-modal__proceed', 'このまま購入へ進む');
      go.type = 'button';
      actions.appendChild(go);
    }
    modal.appendChild(actions);

    cont.addEventListener('click', dismissNudge);
    close.addEventListener('click', dismissNudge);
    if (go) go.addEventListener('click', proceed);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) dismissNudge(); });

    state.onKeydown = function (e) {
      if (!state.overlay) return;
      if (e.key === 'Escape') { e.preventDefault(); dismissNudge(); return; }
      if (e.key !== 'Tab') return;
      var f = getFocusable();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', state.onKeydown, true);

    document.body.appendChild(overlay);
    lockScroll();
    if (picker) selectTab(state.activeTab);
    renderShipping();
    renderCapacity();
    syncPicker();
    syncAge();
    modal.focus();
  }

  /* ---------- 発火 ---------- */

  function setup() {
    // 「カートに追加」した時点で設定を先読み（この直後に通知ポップアップが出る）
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) warmConfig();
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[name="add"]')) warmConfig();
    }, true);

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('button[name="checkout"], button#checkout');
      if (!btn) return;

      // 年齢確認があるページ（カート）で未チェックなら年齢確認ハンドラに委譲（モーダルは出さない）
      var ageCb = document.getElementById('age-verification-checkbox');
      if (ageCb && !ageCb.checked) return;

      // 同セッション中に一度見たナッジはスキップする。ただし年齢確認がまだなら
      // （通知ポップアップ経由＝ページに年齢チェックボックスが無い場合）素通りさせない。
      var seen = false;
      try { seen = !!sessionStorage.getItem(SEEN_KEY); } catch (e2) {}
      var ageDone = !!ageCb;
      if (!ageDone) {
        try { ageDone = !!sessionStorage.getItem(AGE_KEY); } catch (e6) {}
      }
      if (ageDone) state.ageConfirmed = true;
      // 以前は「ナッジ既読 かつ 年齢確認済み」ならここで素通りさせていたが、
      // 個人輸入の上限超過は既読フラグに関係なく止めなければならないので必ず非同期判定へ進む。
      // 上限内と分かった時点で passThrough() するので、体感は従来とほぼ変わらない。

      // カートページ以外（カート追加通知ポップアップ）では設定JSONがまだDOMに無く、
      // 取り寄せてからでないと出す/出さないを判定できない。
      // そのため「設定が無い＝素通り」ではなく、いったん送信を止めて非同期で判定する。
      e.preventDefault();
      e.stopPropagation();

      state.trigger = btn;
      // 前回クリック時の判定を持ち越さない（持ち越すと submitCheckout が黙って止まり
      // 数量を直したあとも購入ボタンが無反応に見える）
      state.blocked = false;

      // ここから先で例外が出ると購入ボタンが無反応になるため、全経路を包んで必ず素通りさせる
      var settled = false;
      function bailOut() {
        if (settled) return;
        settled = true;
        clearTimeout(watchdog);
        try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e3) {}
        try { closeNudge(); } catch (e4) {}
        submitCheckout();
      }
      function passThrough() {
        if (settled) return;
        settled = true;
        clearTimeout(watchdog);
        try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e5) {}
        submitCheckout();
      }
      // 通信が詰まったまま返らない場合でも購入ボタンを死なせない
      var watchdog = setTimeout(bailOut, 6000);

      ensureConfig()
        .then(function () {
          // 上限判定は送料ナッジの設定（enabled / threshold）に依存させない。
          // ナッジを止めても購入をブロックできなくなってはいけないため、
          // 先に容量まわりだけを読んでカートを取りに行く。
          var cfg = readJson('nc-shipping-config');
          var addons = readJson('nc-cart-addons');
          state.addons = addons;
          state.mlPerUnit = Math.max(1, Number(addons && addons.mlPerUnit) || 20);
          state.mlLimit = Math.max(0, Number(addons && addons.mlLimit) || 0);
          state.unitLimit = state.mlLimit > 0 ? Math.floor(state.mlLimit / state.mlPerUnit) : 0;
          state.unitMap = (addons && addons.unitMap) || {};

          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              applyCart(cart);

              // 個人輸入の上限超過は最優先で止める（既読フラグ・年齢確認より前）。
              // 通常はネットワーク層のガード（nc-ml-guard.js）が超過を作らせないので、
              // ここに来るのは上限導入前から残っているカートなどの例外ケース。
              state.blocked = state.unitLimit > 0 && !state.unknown && state.units > state.unitLimit;
              if (state.blocked) {
                closeCartNotification();
                openNudge();
                settled = true;
                clearTimeout(watchdog);
                return;
              }

              // ここから先はナッジの話。設定が無効／閾値未設定なら素通りさせる。
              if (!cfg || !cfg.enabled) { passThrough(); return; }
              var threshold = Number(cfg.threshold) || 0;
              if (threshold <= 0) { passThrough(); return; }
              state.cfg = cfg;

              // RICHILL だけのカートは送料一律・容量の上限も無関係なので、買い足しの案内は出さない
              var needShip = !state.flatOnly && !state.freeShipCode && state.totalYen < threshold;
              var needMl = !state.flatOnly && state.unitLimit > 0 && !state.unknown && state.units < state.unitLimit;
              var needNudge = (needShip || needMl) && !seen;
              // 年齢確認が済んでいなければ、ナッジ不要でもモーダルを出して確認を取る
              var needAge = ageRequired();

              if (!needNudge && !needAge) {
                passThrough();
                return;
              }
              // 通知ポップアップの focus trap とモーダルが競合するため先に閉じる
              closeCartNotification();
              openNudge();
              // openNudge が投げた場合は下の catch で素通りさせたいので、成功後に確定する
              settled = true;
              clearTimeout(watchdog);
            });
        })
        .catch(function (err) {
          // 設定の取得失敗・カート取得失敗・描画中の例外いずれの場合も購入を妨げず素通り
          if (window.console && console.warn) console.warn('[nicochill] nudge failed, proceeding to checkout', err);
          bailOut();
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();



/* ============================================
 * NICOCHILL Product card バッジ（最短2営業日）動的注入
 * ============================================ */
(function () {
  function inject() {
    var targets = document.querySelectorAll('.card-information');
    targets.forEach(function(el) {
      if (el.querySelector('.nc-card-badges')) return;
      // 商品カードのみ: 価格があるか確認
      var card = el.closest('.card-wrapper, .card, .grid__item');
      if (!card || !card.querySelector('.price')) return;
      // フレーバーカード等は除外
      if (card.closest('.flavor-showcase__card')) return;

      var div = document.createElement('div');
      div.className = 'nc-card-badges';

      var b = document.createElement('span');
      b.className = 'nc-badge nc-badge--ship';
      b.textContent = '最短2営業日';
      div.appendChild(b);

      el.appendChild(div);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  // 動的ロード対応
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function(){ inject(); });
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();


/* ============================================
 * NICOCHILL 緊急性トリガー: 配送日カウントダウン + 限定オファー
 * - 商品ページにのみ表示
 * ============================================ */
(function () {
  function formatDate(d) {
    var m = d.getMonth() + 1;
    var dd = d.getDate();
    var dow = ['日','月','火','水','木','金','土'][d.getDay()];
    return m + '月' + dd + '日(' + dow + ')';
  }
  function nextBusinessDays(daysAhead) {
    var d = new Date();
    var added = 0;
    while (added < daysAhead) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function inject() {
    // 商品ページか判定 (URL に /products/ が入っている)
    if (!/\/products\//.test(location.pathname)) return;

    // すでに挿入済みならスキップ
    if (document.querySelector('.nc-urgency')) return;

    // ノンニコチン（国内発送・一律¥450）の商品ページには段の送料と海外発送の日数を出さない
    if (document.querySelector('[data-nc-flat-ship]')) return;

    // カートに追加ボタンを起点にする
    var atc = document.querySelector('button[name="add"], product-form button[type="submit"]');
    if (!atc) return;

    var minDeliveryDate = nextBusinessDays(2);
    var maxDeliveryDate = nextBusinessDays(4);

    var urgency = document.createElement('div');
    urgency.className = 'nc-urgency';

    // Row 1: お届け予定
    var row1 = document.createElement('div');
    row1.className = 'nc-urgency__row';
    row1.innerHTML =
      '<span class="nc-urgency__icon">📦</span>' +
      '<span class="nc-urgency__label">お届け予定:</span>' +
      '<span class="nc-urgency__value nc-urgency__value--accent">' + formatDate(minDeliveryDate) + '</span>' +
      '<span class="nc-urgency__label">〜 ' + formatDate(maxDeliveryDate) + '</span>';
    urgency.appendChild(row1);

    // Row 2: 送料の案内（3段階）
    var row2 = document.createElement('div');
    row2.className = 'nc-urgency__row';
    row2.innerHTML =
      '<span class="nc-urgency__icon">🚚</span>' +
      '<span class="nc-urgency__label">送料<span class="nc-urgency__value">¥4,000</span>（税込）／¥10,000以上で<span class="nc-urgency__value">¥2,000</span>／¥15,000以上で<span class="nc-urgency__value">無料</span></span>';
    urgency.appendChild(row2);

    // Row 3: スターターパックの場合は限定マーク
    var titleEl = document.querySelector('.product__title h1, h1.product__title');
    var titleText = titleEl ? titleEl.textContent : '';
    if (titleText.indexOf('スターターパック') >= 0 || /starter-pack/.test(location.pathname)) {
      var row3 = document.createElement('div');
      row3.className = 'nc-urgency__row';
      row3.innerHTML =
        '<span class="nc-urgency__icon">🎁</span>' +
        '<span class="nc-urgency__starter">オープン記念 / お一人様1セットまで</span>';
      urgency.appendChild(row3);
    }

    // ボタン直前に挿入
    var formContainer = atc.closest('product-form, form, .product-form');
    if (formContainer && formContainer.parentNode) {
      formContainer.parentNode.insertBefore(urgency, formContainer);
    } else {
      atc.parentNode.insertBefore(urgency, atc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();

/* ============================================
 * FV split hero — 右ペインの自動スライドショー
 * （インラインscriptだとCSP/テーマエディタで動かないため外部JS化）
 * ============================================ */
(function () {
  if (typeof document === 'undefined') return;

  function initSlides() {
    var boxes = document.querySelectorAll('[data-nc-slides]');
    for (var b = 0; b < boxes.length; b++) {
      var box = boxes[b];
      if (box.dataset.ncStarted) continue;
      var slides = box.querySelectorAll('.nc-fvbar__product');
      if (slides.length < 2) continue;
      box.dataset.ncStarted = '1';
      startRotation(box, slides);
    }
  }

  // 2枚目以降は data-src で出力されている（初期表示の帯域を LCP 画像に譲るため）。
  // ページの load 後に src を入れて初めて取得が始まる。load が極端に遅い環境でも
  // スライドが止まったままにならないよう、6秒でタイムアウトして流し込む。
  function hydrate(slides, done) {
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      for (var k = 0; k < slides.length; k++) {
        var s = slides[k];
        if (s.dataset.srcset && !s.getAttribute('srcset')) s.setAttribute('srcset', s.dataset.srcset);
        if (s.dataset.sizes && !s.getAttribute('sizes')) s.setAttribute('sizes', s.dataset.sizes);
        if (s.dataset.src && !s.getAttribute('src')) s.setAttribute('src', s.dataset.src);
      }
      done();
    }
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
    setTimeout(go, 6000);
  }

  function startRotation(box, slides) {
    var interval = parseInt(box.getAttribute('data-interval'), 10) || 3000;
    var i = 0, timer = null, ready = false;
    function step() {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }
    // ready になるまで回さない。切り替えた先がまだ空の img だと画面が白くなる。
    function start() { if (ready && !timer) timer = setInterval(step, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    hydrate(slides, function () { ready = true; if (!document.hidden) start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlides);
  } else {
    initSlides();
  }
})();
